import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  TemplateRef
} from '@angular/core';
import {StandardFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';
import {extractValue} from '../standard-form-builder/standard-form.helpers';
import {LocaleService} from '../../../../../src/app/shared/services/locale.service';
import { InsparkTemplate } from '@inspark/inspark-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-onecolumn-form-bulder',
    templateUrl: './onecolumn-form-bulder.component.html',
    styleUrls: ['./onecolumn-form-bulder.component.scss'],
    standalone: false
})
export class OnecolumnFormBulderComponent implements OnInit, OnChanges, AfterContentInit {
  @Input() isOneColumn = false;
  @Input() meta: StandardFormMetaInfo[];
  @Input() values: any;
  @Input() itemOptions = {deviceparams: [], calcparams: []};
  @Input() updatePrivilege? = true;
  @Input() buttons;
  @Input() buttonsLabels: { save?: string; create?: string; copy?: string; delete?: string; savetitle?: string; operatingmode?: string; timeschedule?: string } =
    {save: 'SAVE', create: 'CREATE', copy: 'COPY', delete: 'DELETE', operatingmode: 'OPERATINGMODE', timeschedule: 'TIMESCHEDULE'};
  @Input() buttonsColor: { save?: string; create?: string; copy?: string; delete?: string; savetitle?: string; operatingmode?: string; timeschedule?: string } =
    {save: 'primary', create: 'primary', copy: 'primary', delete: 'primary', operatingmode: 'primary', timeschedule: 'primary'};
  @Input() buttonsDisabled: { save?: boolean; create?: boolean; copy?: boolean; delete?: boolean} =
    {save: false, create: false, copy: false, delete: false};
  @Input() disable;
  @Input() isCompactMode = false;
  @Input() fullHeight = false;
  @Output() save = new EventEmitter<any>();
  @Output() create = new EventEmitter<any>();
  @Output() duplicate = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @ContentChildren(InsparkTemplate) templates: QueryList<InsparkTemplate>;
  readonly DEFAULT_MAX_LENGTH = 65535;
  disabled = {save: true, create: true, copy: true};
  bodyTemplate: TemplateRef<any>;
  valueTemplate: TemplateRef<any>;
  calendarLocale;
  emptyOption = {
    label: null,
    value: null
  };

  constructor(
    private localeService: LocaleService,
    private translateService: TranslateService
  ) {
    this.calendarLocale = this.localeService.getCalendarLocale();
  }

  ngOnInit() {
    return;
  }

  ngOnChanges() {
    this.checkRequired();
    this.mapDisabled();
  }

  onSave() {
    this.save.next(this.values);
  }

  onCreate() {
    this.create.next(this.values);
  }

  onDuplicate() {
    this.duplicate.next(this.values);
  }

  onDelete() {
    this.delete.next(this.values);
  }

  checkRequired() {
    if (this.meta.find(_meta => _meta.required && !this.values[_meta.field])) {
      this.disabled.save = true;
      this.disabled.create = true;
      this.disabled.copy = true;
      return;
    }
    this.disabled.save = false || this.buttonsDisabled.save;
    this.disabled.create = false || this.buttonsDisabled.create;
    this.disabled.copy = false || this.buttonsDisabled.copy;
  }

  mapDisabled() {
    this.meta.forEach(metaInfo => {
      if (metaInfo.disabledMap && metaInfo.disabledMap.length) {
        metaInfo.disabled = (metaInfo.disabledMap.map(f => f(this.values)).filter(r => r === true) || []).length > 0;
      }
    });
  }

  /**
   * Транcформирует значение поля в null, если ничего не выбрано для in-dropdown.
   *
   * @param val - текущее значение in-dropdown из $event
   * @param fieldName - названия поля в объекте value
   */
  transformEmpty(val, fieldName) {
    if (!val || val.isEmpty) {
      this.values[fieldName] = null;
    }
  }

  compareById(a, b) {
    if (a === null || b === null) {
      return false;
    }
    if (a && b && (a.id === undefined || b.id === undefined)) {
      return a && b && a === b;
    }
    return a && b && a.id === b.id;
  }

  compareByValue(a, b) {
    return a && b && a === b;
  }

  getCompositeValue(value, field) {
    field.forEach(key => value = value[key]);
    return value;
  }

  filterItems(itemInfo) {
    const from = itemInfo.filter.fromField;
    const to = itemInfo.filter.toField;
    const category = itemInfo.filter.categoryField;
    const filterObj = (this.itemOptions[itemInfo.filter.options] || []).find(_v => this.values[itemInfo.filter.key] && +_v.id === +this.values[itemInfo.filter.key].id);
    const items = this.itemOptions[itemInfo.item.options];

    if (filterObj) {
      const filtered = items.filter(
        _item =>
          +extractValue(_item, from, -1) === +extractValue(filterObj, to, -2));
      const categories = {};
      filtered.forEach(_fitem => {
        const categoryName = extractValue(_fitem, category, '');
        categories[categoryName] = categories[categoryName] || [];
        categories[categoryName].push(_fitem);
      });
      return categories;
    }
    return {list: items};
  }

  getValue(values, info) {
    let result;
    try {
      result = info.value(values);
    } catch (e) {
      result = '';
    }

    return result;
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterContentInit() {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'body':
          this.bodyTemplate = item.template;
          break;
        case 'value':
          this.valueTemplate = item.template;
          break;

      }
    });
  }
}
